import {tick} from "svelte";

export function printAppPoweredLog() {
    tick().then(() => {

        console.log(`%cUpsell & Cross-Sell powered by Fast Simon`,
            'font-weight: bold; color: darkgreen'
        );
    });
}